/* THIS IS A GENERATED FILE. PLEASE DO NOT MODIFY!! */
import * as Types from '../../../../types/dashboard-core-gqlTypes.generated.d';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type BaseOrganizationFragmentGQLType = (
  { __typename?: 'BaseOrganization' }
  & Pick<Types.BaseOrganizationGQLType, 'id' | 'name' | 'slug'>
);

export type GetOrganizationQueryVariablesGQLType = Types.Exact<{
  organizationId: Types.Scalars['UUID'];
}>;


export type GetOrganizationQueryGQLType = (
  { __typename?: 'Query' }
  & { organization: (
    { __typename?: 'Organization' }
    & Pick<Types.OrganizationGQLType, 'id' | 'slug' | 'name' | 'type'>
    & { users: Array<(
      { __typename?: 'User' }
      & Pick<Types.UserGQLType, 'id' | 'firstName' | 'lastName' | 'email' | 'roleType'>
    )> }
  ) }
);

export type GetOrganizationActiveCreditFacilitiesQueryVariablesGQLType = Types.Exact<{
  organizationId: Types.Scalars['UUID'];
}>;


export type GetOrganizationActiveCreditFacilitiesQueryGQLType = (
  { __typename?: 'Query' }
  & { organization: (
    { __typename?: 'Organization' }
    & Pick<Types.OrganizationGQLType, 'id' | 'slug' | 'name' | 'type'>
    & { creditFacilities: Array<(
      { __typename?: 'CreditFacility' }
      & Pick<Types.CreditFacilityGQLType, 'id' | 'slug' | 'name'>
    )> }
  ) }
);

export type GetOrganizationsByIdsQueryVariablesGQLType = Types.Exact<{
  organizationIds: Array<Types.Scalars['UUID']> | Types.Scalars['UUID'];
}>;


export type GetOrganizationsByIdsQueryGQLType = (
  { __typename?: 'Query' }
  & { organizationsByIds: Array<(
    { __typename?: 'Organization' }
    & Pick<Types.OrganizationGQLType, 'id' | 'slug' | 'name' | 'type'>
  )> }
);

export type GetOrganizationsByIdsWithUsersQueryVariablesGQLType = Types.Exact<{
  organizationIds: Array<Types.Scalars['UUID']> | Types.Scalars['UUID'];
}>;


export type GetOrganizationsByIdsWithUsersQueryGQLType = (
  { __typename?: 'Query' }
  & { organizationsByIds: Array<(
    { __typename?: 'Organization' }
    & Pick<Types.OrganizationGQLType, 'id' | 'slug' | 'name' | 'type'>
    & { users: Array<(
      { __typename?: 'User' }
      & Pick<Types.UserGQLType, 'id' | 'firstName' | 'lastName' | 'email' | 'roleType'>
    )> }
  )> }
);

export type GetCapitalProvidersQueryVariablesGQLType = Types.Exact<{
  creditFacilityId: Types.Scalars['UUID'];
}>;


export type GetCapitalProvidersQueryGQLType = (
  { __typename?: 'Query' }
  & { capitalProviders: Array<(
    { __typename?: 'Organization' }
    & Pick<Types.OrganizationGQLType, 'id' | 'name' | 'type' | 'slug'>
  )> }
);

export type GetPartiesByTypeAndCreditFacilityIdsQueryVariablesGQLType = Types.Exact<{
  creditFacilityIds: Array<Types.Scalars['UUID']> | Types.Scalars['UUID'];
  partyType: Types.PartyTypeGQLType;
}>;


export type GetPartiesByTypeAndCreditFacilityIdsQueryGQLType = (
  { __typename?: 'Query' }
  & { partiesByTypeAndCreditFacilityIds: Array<(
    { __typename?: 'Organization' }
    & Pick<Types.OrganizationGQLType, 'id' | 'name' | 'type' | 'slug'>
  )> }
);

export type GetOrganizationLoanProductsQueryVariablesGQLType = Types.Exact<{
  organizationId: Types.Scalars['UUID'];
}>;


export type GetOrganizationLoanProductsQueryGQLType = (
  { __typename?: 'Query' }
  & { organization: (
    { __typename?: 'Organization' }
    & Pick<Types.OrganizationGQLType, 'id' | 'slug'>
    & { loanProducts: Array<(
      { __typename?: 'LoanProduct' }
      & Pick<Types.LoanProductGQLType, 'id' | 'name' | 'slug' | 'implementationId'>
      & { currentMasterLoanTape?: Types.Maybe<(
        { __typename?: 'MasterLoanTapeMetadata' }
        & Pick<Types.MasterLoanTapeMetadataGQLType, 'id' | 'fileVersion' | 'reportingDate'>
      )> }
    )> }
  ) }
);

export type GetOrganizationLoanProductsByCreditFacilityQueryVariablesGQLType = Types.Exact<{
  organizationId: Types.Scalars['UUID'];
}>;


export type GetOrganizationLoanProductsByCreditFacilityQueryGQLType = (
  { __typename?: 'Query' }
  & { result: (
    { __typename?: 'Organization' }
    & { creditFacilities: Array<(
      { __typename?: 'CreditFacility' }
      & Pick<Types.CreditFacilityGQLType, 'id' | 'slug' | 'name'>
      & { loanProducts: Array<(
        { __typename?: 'LoanProduct' }
        & Pick<Types.LoanProductGQLType, 'id' | 'slug' | 'name'>
      )> }
    )> }
  ) }
);

export type GetAthenaSchemaForOrganizationQueryVariablesGQLType = Types.Exact<{
  organizationId: Types.Scalars['String'];
}>;


export type GetAthenaSchemaForOrganizationQueryGQLType = (
  { __typename?: 'Query' }
  & { athenaTables: Array<(
    { __typename?: 'AthenaTable' }
    & Pick<Types.AthenaTableGQLType, 'tableName'>
    & { properties: Array<(
      { __typename?: 'AthenaTableProperty' }
      & Pick<Types.AthenaTablePropertyGQLType, 'name' | 'type'>
    )> }
  )> }
);

export type CreateUserMutationVariablesGQLType = Types.Exact<{
  userData: Types.CreateUserGQLType;
}>;


export type CreateUserMutationGQLType = (
  { __typename?: 'Mutation' }
  & { createUser?: Types.Maybe<(
    { __typename?: 'UserObject' }
    & Pick<Types.UserObjectGQLType, 'id' | 'firstName' | 'lastName' | 'email' | 'roleType'>
  )> }
);

export type RemoveUserMutationVariablesGQLType = Types.Exact<{
  userId: Types.Scalars['UUID'];
  organizationId: Types.Scalars['UUID'];
}>;


export type RemoveUserMutationGQLType = (
  { __typename?: 'Mutation' }
  & Pick<Types.MutationGQLType, 'removeUser'>
);

export type UpdateUserMutationVariablesGQLType = Types.Exact<{
  settings: Types.UpdateUserSettingsGQLType;
}>;


export type UpdateUserMutationGQLType = (
  { __typename?: 'Mutation' }
  & { updateUserSettingsWithRole?: Types.Maybe<(
    { __typename?: 'UserObject' }
    & Pick<Types.UserObjectGQLType, 'id' | 'email' | 'firstName' | 'lastName' | 'roleType'>
  )> }
);

export type UpdateLoanProductNameMutationVariablesGQLType = Types.Exact<{
  id: Types.Scalars['UUID'];
  newName: Types.Scalars['String'];
}>;


export type UpdateLoanProductNameMutationGQLType = (
  { __typename?: 'Mutation' }
  & { updateLoanProductName: (
    { __typename?: 'LoanProduct' }
    & Pick<Types.LoanProductGQLType, 'name'>
  ) }
);

export const BaseOrganizationFragmentDocGQLType = gql`
    fragment BaseOrganization on BaseOrganization {
  id
  name
  slug
}
    `;
export const GetOrganizationDocumentGQLType = gql`
    query getOrganization($organizationId: UUID!) {
  organization(organizationId: $organizationId) {
    id
    slug
    name
    type
    users {
      id
      firstName
      lastName
      email
      roleType
    }
  }
}
    `;

/**
 * __useGetOrganizationQuery__
 *
 * To run a query within a React component, call `useGetOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetOrganizationQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationQueryGQLType, GetOrganizationQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationQueryGQLType, GetOrganizationQueryVariablesGQLType>(GetOrganizationDocumentGQLType, options);
      }
export function useGetOrganizationLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationQueryGQLType, GetOrganizationQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationQueryGQLType, GetOrganizationQueryVariablesGQLType>(GetOrganizationDocumentGQLType, options);
        }
export type GetOrganizationQueryHookResult = ReturnType<typeof useGetOrganizationQuery>;
export type GetOrganizationLazyQueryGQLTypeHookResult = ReturnType<typeof useGetOrganizationLazyQueryGQLType>;
export type GetOrganizationQueryResultGQLType = Apollo.QueryResult<GetOrganizationQueryGQLType, GetOrganizationQueryVariablesGQLType>;
export const GetOrganizationActiveCreditFacilitiesDocumentGQLType = gql`
    query getOrganizationActiveCreditFacilities($organizationId: UUID!) {
  organization(organizationId: $organizationId) {
    id
    slug
    name
    type
    creditFacilities {
      id
      slug
      name
    }
  }
}
    `;

/**
 * __useGetOrganizationActiveCreditFacilitiesQuery__
 *
 * To run a query within a React component, call `useGetOrganizationActiveCreditFacilitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationActiveCreditFacilitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationActiveCreditFacilitiesQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetOrganizationActiveCreditFacilitiesQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationActiveCreditFacilitiesQueryGQLType, GetOrganizationActiveCreditFacilitiesQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationActiveCreditFacilitiesQueryGQLType, GetOrganizationActiveCreditFacilitiesQueryVariablesGQLType>(GetOrganizationActiveCreditFacilitiesDocumentGQLType, options);
      }
export function useGetOrganizationActiveCreditFacilitiesLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationActiveCreditFacilitiesQueryGQLType, GetOrganizationActiveCreditFacilitiesQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationActiveCreditFacilitiesQueryGQLType, GetOrganizationActiveCreditFacilitiesQueryVariablesGQLType>(GetOrganizationActiveCreditFacilitiesDocumentGQLType, options);
        }
export type GetOrganizationActiveCreditFacilitiesQueryHookResult = ReturnType<typeof useGetOrganizationActiveCreditFacilitiesQuery>;
export type GetOrganizationActiveCreditFacilitiesLazyQueryGQLTypeHookResult = ReturnType<typeof useGetOrganizationActiveCreditFacilitiesLazyQueryGQLType>;
export type GetOrganizationActiveCreditFacilitiesQueryResultGQLType = Apollo.QueryResult<GetOrganizationActiveCreditFacilitiesQueryGQLType, GetOrganizationActiveCreditFacilitiesQueryVariablesGQLType>;
export const GetOrganizationsByIdsDocumentGQLType = gql`
    query getOrganizationsByIds($organizationIds: [UUID!]!) {
  organizationsByIds(organizationIds: $organizationIds) {
    id
    slug
    name
    type
  }
}
    `;

/**
 * __useGetOrganizationsByIdsQuery__
 *
 * To run a query within a React component, call `useGetOrganizationsByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationsByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationsByIdsQuery({
 *   variables: {
 *      organizationIds: // value for 'organizationIds'
 *   },
 * });
 */
export function useGetOrganizationsByIdsQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationsByIdsQueryGQLType, GetOrganizationsByIdsQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationsByIdsQueryGQLType, GetOrganizationsByIdsQueryVariablesGQLType>(GetOrganizationsByIdsDocumentGQLType, options);
      }
export function useGetOrganizationsByIdsLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationsByIdsQueryGQLType, GetOrganizationsByIdsQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationsByIdsQueryGQLType, GetOrganizationsByIdsQueryVariablesGQLType>(GetOrganizationsByIdsDocumentGQLType, options);
        }
export type GetOrganizationsByIdsQueryHookResult = ReturnType<typeof useGetOrganizationsByIdsQuery>;
export type GetOrganizationsByIdsLazyQueryGQLTypeHookResult = ReturnType<typeof useGetOrganizationsByIdsLazyQueryGQLType>;
export type GetOrganizationsByIdsQueryResultGQLType = Apollo.QueryResult<GetOrganizationsByIdsQueryGQLType, GetOrganizationsByIdsQueryVariablesGQLType>;
export const GetOrganizationsByIdsWithUsersDocumentGQLType = gql`
    query getOrganizationsByIdsWithUsers($organizationIds: [UUID!]!) {
  organizationsByIds(organizationIds: $organizationIds) {
    id
    slug
    name
    type
    users {
      id
      firstName
      lastName
      email
      roleType
    }
  }
}
    `;

/**
 * __useGetOrganizationsByIdsWithUsersQuery__
 *
 * To run a query within a React component, call `useGetOrganizationsByIdsWithUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationsByIdsWithUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationsByIdsWithUsersQuery({
 *   variables: {
 *      organizationIds: // value for 'organizationIds'
 *   },
 * });
 */
export function useGetOrganizationsByIdsWithUsersQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationsByIdsWithUsersQueryGQLType, GetOrganizationsByIdsWithUsersQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationsByIdsWithUsersQueryGQLType, GetOrganizationsByIdsWithUsersQueryVariablesGQLType>(GetOrganizationsByIdsWithUsersDocumentGQLType, options);
      }
export function useGetOrganizationsByIdsWithUsersLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationsByIdsWithUsersQueryGQLType, GetOrganizationsByIdsWithUsersQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationsByIdsWithUsersQueryGQLType, GetOrganizationsByIdsWithUsersQueryVariablesGQLType>(GetOrganizationsByIdsWithUsersDocumentGQLType, options);
        }
export type GetOrganizationsByIdsWithUsersQueryHookResult = ReturnType<typeof useGetOrganizationsByIdsWithUsersQuery>;
export type GetOrganizationsByIdsWithUsersLazyQueryGQLTypeHookResult = ReturnType<typeof useGetOrganizationsByIdsWithUsersLazyQueryGQLType>;
export type GetOrganizationsByIdsWithUsersQueryResultGQLType = Apollo.QueryResult<GetOrganizationsByIdsWithUsersQueryGQLType, GetOrganizationsByIdsWithUsersQueryVariablesGQLType>;
export const GetCapitalProvidersDocumentGQLType = gql`
    query GetCapitalProviders($creditFacilityId: UUID!) {
  capitalProviders(creditFacilityId: $creditFacilityId) {
    id
    name
    type
    slug
  }
}
    `;

/**
 * __useGetCapitalProvidersQuery__
 *
 * To run a query within a React component, call `useGetCapitalProvidersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCapitalProvidersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCapitalProvidersQuery({
 *   variables: {
 *      creditFacilityId: // value for 'creditFacilityId'
 *   },
 * });
 */
export function useGetCapitalProvidersQuery(baseOptions: Apollo.QueryHookOptions<GetCapitalProvidersQueryGQLType, GetCapitalProvidersQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCapitalProvidersQueryGQLType, GetCapitalProvidersQueryVariablesGQLType>(GetCapitalProvidersDocumentGQLType, options);
      }
export function useGetCapitalProvidersLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetCapitalProvidersQueryGQLType, GetCapitalProvidersQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCapitalProvidersQueryGQLType, GetCapitalProvidersQueryVariablesGQLType>(GetCapitalProvidersDocumentGQLType, options);
        }
export type GetCapitalProvidersQueryHookResult = ReturnType<typeof useGetCapitalProvidersQuery>;
export type GetCapitalProvidersLazyQueryGQLTypeHookResult = ReturnType<typeof useGetCapitalProvidersLazyQueryGQLType>;
export type GetCapitalProvidersQueryResultGQLType = Apollo.QueryResult<GetCapitalProvidersQueryGQLType, GetCapitalProvidersQueryVariablesGQLType>;
export const GetPartiesByTypeAndCreditFacilityIdsDocumentGQLType = gql`
    query GetPartiesByTypeAndCreditFacilityIds($creditFacilityIds: [UUID!]!, $partyType: PartyType!) {
  partiesByTypeAndCreditFacilityIds(
    creditFacilityIds: $creditFacilityIds
    partyType: $partyType
  ) {
    id
    name
    type
    slug
  }
}
    `;

/**
 * __useGetPartiesByTypeAndCreditFacilityIdsQuery__
 *
 * To run a query within a React component, call `useGetPartiesByTypeAndCreditFacilityIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPartiesByTypeAndCreditFacilityIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPartiesByTypeAndCreditFacilityIdsQuery({
 *   variables: {
 *      creditFacilityIds: // value for 'creditFacilityIds'
 *      partyType: // value for 'partyType'
 *   },
 * });
 */
export function useGetPartiesByTypeAndCreditFacilityIdsQuery(baseOptions: Apollo.QueryHookOptions<GetPartiesByTypeAndCreditFacilityIdsQueryGQLType, GetPartiesByTypeAndCreditFacilityIdsQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPartiesByTypeAndCreditFacilityIdsQueryGQLType, GetPartiesByTypeAndCreditFacilityIdsQueryVariablesGQLType>(GetPartiesByTypeAndCreditFacilityIdsDocumentGQLType, options);
      }
export function useGetPartiesByTypeAndCreditFacilityIdsLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetPartiesByTypeAndCreditFacilityIdsQueryGQLType, GetPartiesByTypeAndCreditFacilityIdsQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPartiesByTypeAndCreditFacilityIdsQueryGQLType, GetPartiesByTypeAndCreditFacilityIdsQueryVariablesGQLType>(GetPartiesByTypeAndCreditFacilityIdsDocumentGQLType, options);
        }
export type GetPartiesByTypeAndCreditFacilityIdsQueryHookResult = ReturnType<typeof useGetPartiesByTypeAndCreditFacilityIdsQuery>;
export type GetPartiesByTypeAndCreditFacilityIdsLazyQueryGQLTypeHookResult = ReturnType<typeof useGetPartiesByTypeAndCreditFacilityIdsLazyQueryGQLType>;
export type GetPartiesByTypeAndCreditFacilityIdsQueryResultGQLType = Apollo.QueryResult<GetPartiesByTypeAndCreditFacilityIdsQueryGQLType, GetPartiesByTypeAndCreditFacilityIdsQueryVariablesGQLType>;
export const GetOrganizationLoanProductsDocumentGQLType = gql`
    query GetOrganizationLoanProducts($organizationId: UUID!) {
  organization(organizationId: $organizationId) {
    id
    slug
    loanProducts {
      id
      name
      slug
      implementationId
      currentMasterLoanTape {
        id
        fileVersion
        reportingDate
      }
    }
  }
}
    `;

/**
 * __useGetOrganizationLoanProductsQuery__
 *
 * To run a query within a React component, call `useGetOrganizationLoanProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationLoanProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationLoanProductsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetOrganizationLoanProductsQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationLoanProductsQueryGQLType, GetOrganizationLoanProductsQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationLoanProductsQueryGQLType, GetOrganizationLoanProductsQueryVariablesGQLType>(GetOrganizationLoanProductsDocumentGQLType, options);
      }
export function useGetOrganizationLoanProductsLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationLoanProductsQueryGQLType, GetOrganizationLoanProductsQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationLoanProductsQueryGQLType, GetOrganizationLoanProductsQueryVariablesGQLType>(GetOrganizationLoanProductsDocumentGQLType, options);
        }
export type GetOrganizationLoanProductsQueryHookResult = ReturnType<typeof useGetOrganizationLoanProductsQuery>;
export type GetOrganizationLoanProductsLazyQueryGQLTypeHookResult = ReturnType<typeof useGetOrganizationLoanProductsLazyQueryGQLType>;
export type GetOrganizationLoanProductsQueryResultGQLType = Apollo.QueryResult<GetOrganizationLoanProductsQueryGQLType, GetOrganizationLoanProductsQueryVariablesGQLType>;
export const GetOrganizationLoanProductsByCreditFacilityDocumentGQLType = gql`
    query GetOrganizationLoanProductsByCreditFacility($organizationId: UUID!) {
  result: organization(organizationId: $organizationId) {
    creditFacilities {
      id
      slug
      name
      loanProducts {
        id
        slug
        name
      }
    }
  }
}
    `;

/**
 * __useGetOrganizationLoanProductsByCreditFacilityQuery__
 *
 * To run a query within a React component, call `useGetOrganizationLoanProductsByCreditFacilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationLoanProductsByCreditFacilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationLoanProductsByCreditFacilityQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetOrganizationLoanProductsByCreditFacilityQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationLoanProductsByCreditFacilityQueryGQLType, GetOrganizationLoanProductsByCreditFacilityQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationLoanProductsByCreditFacilityQueryGQLType, GetOrganizationLoanProductsByCreditFacilityQueryVariablesGQLType>(GetOrganizationLoanProductsByCreditFacilityDocumentGQLType, options);
      }
export function useGetOrganizationLoanProductsByCreditFacilityLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationLoanProductsByCreditFacilityQueryGQLType, GetOrganizationLoanProductsByCreditFacilityQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationLoanProductsByCreditFacilityQueryGQLType, GetOrganizationLoanProductsByCreditFacilityQueryVariablesGQLType>(GetOrganizationLoanProductsByCreditFacilityDocumentGQLType, options);
        }
export type GetOrganizationLoanProductsByCreditFacilityQueryHookResult = ReturnType<typeof useGetOrganizationLoanProductsByCreditFacilityQuery>;
export type GetOrganizationLoanProductsByCreditFacilityLazyQueryGQLTypeHookResult = ReturnType<typeof useGetOrganizationLoanProductsByCreditFacilityLazyQueryGQLType>;
export type GetOrganizationLoanProductsByCreditFacilityQueryResultGQLType = Apollo.QueryResult<GetOrganizationLoanProductsByCreditFacilityQueryGQLType, GetOrganizationLoanProductsByCreditFacilityQueryVariablesGQLType>;
export const GetAthenaSchemaForOrganizationDocumentGQLType = gql`
    query GetAthenaSchemaForOrganization($organizationId: String!) {
  athenaTables: getAthenaTablesForOrganization(
    organizationId: $organizationId
    tablePrefixes: ["receivable_response_tapes"]
  ) {
    tableName
    properties {
      name
      type
    }
  }
}
    `;

/**
 * __useGetAthenaSchemaForOrganizationQuery__
 *
 * To run a query within a React component, call `useGetAthenaSchemaForOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAthenaSchemaForOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAthenaSchemaForOrganizationQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetAthenaSchemaForOrganizationQuery(baseOptions: Apollo.QueryHookOptions<GetAthenaSchemaForOrganizationQueryGQLType, GetAthenaSchemaForOrganizationQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAthenaSchemaForOrganizationQueryGQLType, GetAthenaSchemaForOrganizationQueryVariablesGQLType>(GetAthenaSchemaForOrganizationDocumentGQLType, options);
      }
export function useGetAthenaSchemaForOrganizationLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetAthenaSchemaForOrganizationQueryGQLType, GetAthenaSchemaForOrganizationQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAthenaSchemaForOrganizationQueryGQLType, GetAthenaSchemaForOrganizationQueryVariablesGQLType>(GetAthenaSchemaForOrganizationDocumentGQLType, options);
        }
export type GetAthenaSchemaForOrganizationQueryHookResult = ReturnType<typeof useGetAthenaSchemaForOrganizationQuery>;
export type GetAthenaSchemaForOrganizationLazyQueryGQLTypeHookResult = ReturnType<typeof useGetAthenaSchemaForOrganizationLazyQueryGQLType>;
export type GetAthenaSchemaForOrganizationQueryResultGQLType = Apollo.QueryResult<GetAthenaSchemaForOrganizationQueryGQLType, GetAthenaSchemaForOrganizationQueryVariablesGQLType>;
export const CreateUserDocumentGQLType = gql`
    mutation createUser($userData: CreateUser!) {
  createUser(userData: $userData) {
    id
    firstName
    lastName
    email
    roleType
  }
}
    `;
export type CreateUserMutationFnGQLType = Apollo.MutationFunction<CreateUserMutationGQLType, CreateUserMutationVariablesGQLType>;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      userData: // value for 'userData'
 *   },
 * });
 */
export function useCreateUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserMutationGQLType, CreateUserMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserMutationGQLType, CreateUserMutationVariablesGQLType>(CreateUserDocumentGQLType, options);
      }
export type CreateUserMutationHookResult = ReturnType<typeof useCreateUserMutation>;
export type CreateUserMutationResultGQLType = Apollo.MutationResult<CreateUserMutationGQLType>;
export type CreateUserMutationOptionsGQLType = Apollo.BaseMutationOptions<CreateUserMutationGQLType, CreateUserMutationVariablesGQLType>;
export const RemoveUserDocumentGQLType = gql`
    mutation removeUser($userId: UUID!, $organizationId: UUID!) {
  removeUser(userId: $userId, organizationId: $organizationId)
}
    `;
export type RemoveUserMutationFnGQLType = Apollo.MutationFunction<RemoveUserMutationGQLType, RemoveUserMutationVariablesGQLType>;

/**
 * __useRemoveUserMutation__
 *
 * To run a mutation, you first call `useRemoveUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeUserMutation, { data, loading, error }] = useRemoveUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useRemoveUserMutation(baseOptions?: Apollo.MutationHookOptions<RemoveUserMutationGQLType, RemoveUserMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveUserMutationGQLType, RemoveUserMutationVariablesGQLType>(RemoveUserDocumentGQLType, options);
      }
export type RemoveUserMutationHookResult = ReturnType<typeof useRemoveUserMutation>;
export type RemoveUserMutationResultGQLType = Apollo.MutationResult<RemoveUserMutationGQLType>;
export type RemoveUserMutationOptionsGQLType = Apollo.BaseMutationOptions<RemoveUserMutationGQLType, RemoveUserMutationVariablesGQLType>;
export const UpdateUserDocumentGQLType = gql`
    mutation updateUser($settings: UpdateUserSettings!) {
  updateUserSettingsWithRole(settings: $settings) {
    id
    email
    firstName
    lastName
    roleType
  }
}
    `;
export type UpdateUserMutationFnGQLType = Apollo.MutationFunction<UpdateUserMutationGQLType, UpdateUserMutationVariablesGQLType>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      settings: // value for 'settings'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutationGQLType, UpdateUserMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutationGQLType, UpdateUserMutationVariablesGQLType>(UpdateUserDocumentGQLType, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResultGQLType = Apollo.MutationResult<UpdateUserMutationGQLType>;
export type UpdateUserMutationOptionsGQLType = Apollo.BaseMutationOptions<UpdateUserMutationGQLType, UpdateUserMutationVariablesGQLType>;
export const UpdateLoanProductNameDocumentGQLType = gql`
    mutation UpdateLoanProductName($id: UUID!, $newName: String!) {
  updateLoanProductName(id: $id, newName: $newName) {
    name
  }
}
    `;
export type UpdateLoanProductNameMutationFnGQLType = Apollo.MutationFunction<UpdateLoanProductNameMutationGQLType, UpdateLoanProductNameMutationVariablesGQLType>;

/**
 * __useUpdateLoanProductNameMutation__
 *
 * To run a mutation, you first call `useUpdateLoanProductNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLoanProductNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLoanProductNameMutation, { data, loading, error }] = useUpdateLoanProductNameMutation({
 *   variables: {
 *      id: // value for 'id'
 *      newName: // value for 'newName'
 *   },
 * });
 */
export function useUpdateLoanProductNameMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLoanProductNameMutationGQLType, UpdateLoanProductNameMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLoanProductNameMutationGQLType, UpdateLoanProductNameMutationVariablesGQLType>(UpdateLoanProductNameDocumentGQLType, options);
      }
export type UpdateLoanProductNameMutationHookResult = ReturnType<typeof useUpdateLoanProductNameMutation>;
export type UpdateLoanProductNameMutationResultGQLType = Apollo.MutationResult<UpdateLoanProductNameMutationGQLType>;
export type UpdateLoanProductNameMutationOptionsGQLType = Apollo.BaseMutationOptions<UpdateLoanProductNameMutationGQLType, UpdateLoanProductNameMutationVariablesGQLType>;